import { render } from "./LoginBox.vue?vue&type=template&id=15b81708"
import script from "./LoginBox.vue?vue&type=script&lang=js"
export * from "./LoginBox.vue?vue&type=script&lang=js"

import "./LoginBox.vue?vue&type=style&index=0&id=15b81708&lang=css"

import exportComponent from "/root/esg_nexus/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__